import axios from "axios";
import backendUrl from "../utils/backendUrl";
export default () => {
  var backendUrlString = backendUrl().concat("/api/");
  return axios.create({
    baseURL: backendUrlString,
  });
};
